import React, { useEffect, useState } from 'react';
import { faPencilAlt } from '@fortawesome/fontawesome-free-solid';

import { iList, iPerson, MenuPinType } from '../../../../shared/interfaces';
import { getDeviceAllowedSee } from '../../../../shared/db/general-db';
import TableSimple from '../../../elements/TableSimple';
import { FaLink } from '../../../elements/fa';
import PeopleIcon from '../../../../assets/svg/people.svg';
import LocalPersonTile from '../../PersonTabPage/LocalPeopleTile';

export const DeviceVisibleToPeople = (props: { deviceId: string; deviceTags: string[], people: iList<iPerson>, isPinned: boolean, title: string, cssOrder?: number, showPin?: boolean }) => {
  const [peopleIds, setPeopleIds] = useState([]);
  const { people, isPinned, showPin, deviceId, deviceTags } = props;
  const deviceTagsKey = [...deviceTags].sort().join('|');
  const [collapsed, setCollapsed] = useState<boolean>(isPinned);

  useEffect(() => {
    let isCurrent = true;

    const getDevicesAllowedOnMount = async () => {
      const peopleIds = await getDeviceAllowedSee(deviceId, deviceTags);

      if (isCurrent) {
        setPeopleIds(peopleIds);
      }
    }

    getDevicesAllowedOnMount();

    return () => {
      isCurrent = false;
    };
  }, [deviceId, deviceTagsKey]);

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [peopleIds.length]);

  const peopleIsEmpty = peopleIds.length === 0;

  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title={<span style={{ fontSize: 11 }}>{props.title}</span>}
      action={null}
      isPinned={isPinned}
      withPin={showPin}
      property={MenuPinType.VISIBLE_TO_PEOPLE}
      order={props.cssOrder}
      leftIcon={null}
    >
      <div>
        {peopleIsEmpty ? null :
          <TableSimple sm striped style={{fontSize: 11, borderCollapse: 'collapse', borderSpacing: 0}}>
            {peopleIds
              .filter((id) => people[id])
              .map((id) => people[id])
              .sort((a,b) => {
                const nameA = a.displayName;
                const nameB = b.displayName;

                if (nameA === undefined) return 1;
                if (nameB === undefined) return -1;

                const numA = nameA.match(/^0*(\d+)$/);
                const numB = nameB.match(/^0*(\d+)$/);

                if (numA && numB) {
                  return parseInt(numA[1], 10) - parseInt(numB[1], 10);
                }

                else if (numA) {
                  return -1;
                }
                else if (numB) {
                  return 1;
                }

                const getLastName = (name) => {
                  const parts = name.trim().split(/\s+/);
                  return parts.length > 1 ? parts.pop().toLowerCase() : parts[0].toLowerCase();
                };

                return getLastName(nameA).localeCompare(getLastName(nameB));
              })
              .map((person) => <tr key={person.id}>
                <td style={{ padding: 0 }}>{person.displayName}</td>
                <td className="text-right" style={{ padding: 0 }}><FaLink icon={faPencilAlt} to={`/person/${person.id}/visible-devices`}
                  style={{ fontSize: 12 }} /></td>
              </tr>)}
          </TableSimple>
        }
      </div>
    </LocalPersonTile>
  );
};
